import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=f583366c&scoped=true&isFirst=true&page=true"
import script from "./index.mpx?vue&type=script&lang=js&isFirst=true&page=true"
export * from "./index.mpx?vue&type=script&lang=js&isFirst=true&page=true"
import style0 from "./index.mpx?vue&type=style&index=0&id=f583366c&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m70860bc5%22%7D&isFirst=true&page=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f583366c",
  null
  
)

export default component.exports